// orderListAtoms.js
import { atom } from 'recoil';

// Existing atoms for filters, page, and limit
export const orderListFilter = atom({
    key: 'orderListFilter',
    default: {
        startDate: '',
        endDate: '',
        orderType: '',
        selected_orderType: '',
        paymentMode: '',
        selected_paymentMode: '',
        paymentStatus: '',
        selected_paymentStatus: ''
    },
});

export const orderListPage = atom({
    key: 'orderListPage',
    default: 1,
});

export const orderListLimit = atom({
    key: 'orderListLimit',
    default: 10,
});


// New atom for search
export const orderListSearch = atom({
    key: 'orderListSearch',
    default: '',
});
// New atom for search
export const orderListTemplate = atom({
    key: 'orderListTemplate',
    default: '',
});

// New atom for search
export const orderListSubject = atom({
    key: 'orderListSubject',
    default: '',
});

